import React from 'react'
import './Success.sass'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import Button from '../Buttons/Button'
import { Portal } from 'react-portal'

const Success = ({ heading, subText, secondary, primary, failed }) => (
  <Portal>
    <div className='defaultSuccess'>
      <div className='container'>
        <h1>{heading}</h1>
        {!failed && <div className='icon' />}
        <p>{subText}</p>
        <div className='buttons'>
          {secondary.hidden ? null : secondary.route ? (
            <Link to={secondary.route}>
              <Button
                onClick={() => {}}
                name={secondary.name}
                type={'secondary big'}
              />
            </Link>
          ) : (
            <Button
              onClick={secondary.action}
              name={secondary.name}
              type={'secondary big'}
            />
          )}

          {primary.hidden ? null : primary.route ? (
            <Link to={primary.route}>
              <Button
                onClick={() => {}}
                name={primary.name}
                type={'primary big'}
              />
            </Link>
          ) : (
            <Button
              onClick={primary.action}
              name={primary.name}
              type={'primary big'}
            />
          )}
        </div>
      </div>
    </div>
  </Portal>
)

export default Success

Success.defaultProps = {
  heading: '',
  subText: '',
  secondary: {
    route: '/',
    name: '',
  },
  primary: {
    route: '/',
    name: '',
  },
  failed: false,
}

Success.propTypes = {
  heading: PropTypes.string.isRequired,
  subText: PropTypes.string.isRequired,
  secondary: PropTypes.shape({
    route: PropTypes.string,
    action: PropTypes.func,
    hidden: PropTypes.bool,
    name: PropTypes.string.isRequired,
  }).isRequired,
  primary: PropTypes.shape({
    route: PropTypes.string,
    action: PropTypes.func,
    hidden: PropTypes.bool,
    name: PropTypes.string.isRequired,
  }).isRequired,
  failed: PropTypes.bool,
}
